import { Component, Inject, Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { DOCUMENT } from '@angular/platform-browser';

@Injectable()
@Component({
  selector: 'app-show-camera-tutorial-modal-base',
  templateUrl: './show-camera-tutorial-modal-base.component.html',
  styleUrls: ['./show-camera-tutorial-modal-base.component.scss']
})

export class ShowCameraTutorialModalBaseComponent {
  constructor(
    public dialogRef: MatDialogRef<ShowCameraTutorialModalBaseComponent>,
    @Inject(DOCUMENT) private document: any
  ) {
    dialogRef.afterClosed().subscribe(result => {
      this.document.body.classList.remove('no-scroll');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/show-camera-tutorial-modal-base/show-camera-tutorial-modal-base.component.ts